module.exports = __webpack_public_path__ + "static/media/copyrightLogo.57dba165.png";